import { apiClient } from './client';
import type { PendingNotification } from '@/types/api';

export async function getAll(): Promise<{ notifications: PendingNotification[] }> {
  return apiClient.get<{ notifications: PendingNotification[] }>('/notifications');
}

export async function acknowledge(id: string): Promise<{ ok: boolean }> {
  return apiClient.post<{ ok: boolean }>(`/notifications/${id}/ack`, {});
}

export async function dismiss(id: string): Promise<{ ok: boolean }> {
  return apiClient.post<{ ok: boolean }>(`/notifications/${id}/dismiss`, {});
}

export async function clearAll(): Promise<{ ok: boolean }> {
  return apiClient.post<{ ok: boolean }>('/notifications/clear', {});
}
